import { usePanier as usePanierFromContext } from "../contexts/PanierContext";

export const usePanier = usePanierFromContext;
